export const techStack = [
  {
    id: 'react',
    name: 'React',
    category: 'Frontend',
    description: 'Component-driven UIs with concurrent rendering and a mature ecosystem.',
    glyph: 'R',
  },
  {
    id: 'node',
    name: 'Node.js',
    category: 'Backend',
    description: 'Event-driven services and APIs with first-class TypeScript support.',
    glyph: 'N',
  },
  {
    id: 'docker',
    name: 'Docker',
    category: 'Containers',
    description: 'Reproducible builds and immutable deployments across any cloud.',
    glyph: 'D',
  },
  {
    id: 'k8s',
    name: 'Kubernetes',
    category: 'Orchestration',
    description: 'Self-healing, autoscaling workloads with declarative rollouts.',
    glyph: 'K',
  },
  {
    id: 'postgres',
    name: 'PostgreSQL',
    category: 'Database',
    description: 'ACID-compliant relational engine with JSON, full-text, and extensions.',
    glyph: 'P',
  },
  {
    id: 'aws',
    name: 'AWS',
    category: 'Cloud',
    description: 'Elastic infrastructure from Lambda to ECS, tuned for cost and latency.',
    glyph: 'A',
  },
];
